import Vuex from 'vuex';

const modules = {};

/**
 * Register a store module
 * @param {string} name - The name of the module
 * @param {Object} module - The module object (contains a state and the mutations)
 */
export function registerStoreModule(name, module) {
    modules[name] = module;
}

/**
 * Create the store instance
 * @param {Object} options - Pass in any additional middleware.
 * @return {Vuex.Store}
 */
export default function createStore({
    plugins,
    strict = false, // FIXME: Disable strict to prevent HMR errors for now
} = {}) {
    return new Vuex.Store({
        modules,
        plugins,
        strict,
    });
}



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/store.js